import React from "react";
import Herosection from "../components/Events/Herosection";
import AllEvents from "../components/Events/Event";

/**
 * Events page — hero stays mounted while cards load (skeleton), then the footer.
 */
const Eventspage = () => {
  return (
    <div className="w-full min-h-[70vh] flex flex-col items-stretch">
      <Herosection />
      <AllEvents />
    </div>
  );
};

export default Eventspage;
